<template>
  <div class="rich-text-editor">
    <div class="rte-toolbar">
      <button type="button" class="rte-btn" title="عريض" @mousedown.prevent="exec('bold')">
        <i class="bi bi-type-bold"></i>
      </button>
      <button type="button" class="rte-btn" title="مائل" @mousedown.prevent="exec('italic')">
        <i class="bi bi-type-italic"></i>
      </button>
      <button type="button" class="rte-btn" title="تسطير" @mousedown.prevent="exec('underline')">
        <i class="bi bi-type-underline"></i>
      </button>

      <span class="rte-separator"></span>

      <select class="rte-select" title="حجم الخط" @mousedown="saveSelection" @change="setFontSize($event)">
        <option value="">حجم الخط</option>
        <option value="8">8</option>
        <option value="10">10</option>
        <option value="11">11</option>
        <option value="12">12</option>
        <option value="14">14</option>
        <option value="16">16</option>
        <option value="18">18</option>
        <option value="20">20</option>
        <option value="24">24</option>
        <option value="28">28</option>
        <option value="32">32</option>
        <option value="36">36</option>
        <option value="48">48</option>
        <option value="72">72</option>
      </select>

      <label class="rte-color-label" title="لون النص" @mousedown="saveSelection">
        <i class="bi bi-palette"></i>
        <input type="color" class="rte-color" @input="setTextColor($event)">
      </label>

      <span class="rte-separator"></span>

      <button type="button" class="rte-btn" title="قائمة نقطية" @mousedown.prevent="exec('insertUnorderedList')">
        <i class="bi bi-list-ul"></i>
      </button>
      <button type="button" class="rte-btn" title="قائمة مرقمة" @mousedown.prevent="exec('insertOrderedList')">
        <i class="bi bi-list-ol"></i>
      </button>

      <span class="rte-separator"></span>

      <button type="button" class="rte-btn" title="إلغاء التنسيق" @mousedown.prevent="exec('removeFormat')">
        <i class="bi bi-eraser"></i>
      </button>
    </div>

    <div
      ref="editable"
      class="rte-content"
      contenteditable="true"
      :data-placeholder="placeholder"
      @input="onInput"
      @blur="onInput"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'TextEditor',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'اكتب هنا...',
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      savedRange: null,
    };
  },
  watch: {
    modelValue(newVal) {
      if (this.$refs.editable && newVal !== this.$refs.editable.innerHTML) {
        this.$refs.editable.innerHTML = newVal || '';
      }
    },
  },
  methods: {
    saveSelection() {
      const sel = window.getSelection();
      if (sel && sel.rangeCount > 0) {
        this.savedRange = sel.getRangeAt(0).cloneRange();
      }
    },
    restoreSelection() {
      if (!this.savedRange) return;
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(this.savedRange);
    },

    exec(command, value = null) {
      document.execCommand(command, false, value);
      this.$refs.editable.focus();
      this.onInput();
    },

    setFontSize(event) {
      const px = event.target.value;
      event.target.selectedIndex = 0;
      if (!px) return;

      this.restoreSelection();
      document.execCommand('fontSize', false, '7');

      const markers = this.$refs.editable.querySelectorAll('font[size="7"]');
      markers.forEach(marker => {
        const span = document.createElement('span');
        span.style.fontSize = px + 'px';
        span.innerHTML = marker.innerHTML;
        marker.parentNode.replaceChild(span, marker);
      });

      this.$refs.editable.focus();
      this.onInput();
    },

    setTextColor(event) {
      this.restoreSelection();
      this.exec('foreColor', event.target.value);
    },

    onInput() {
      this.$emit('update:modelValue', this.$refs.editable.innerHTML);
    },
  },
  mounted() {
    if (this.modelValue)
      this.$refs.editable.innerHTML = this.modelValue;
  },
}
</script>

<style scoped>
.rich-text-editor {
  border: 1px solid #ced4da;
  border-radius: .375rem;
  overflow: hidden;
}
.rte-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  padding: 6px 8px;
  background: #f8f9fa;
  border-bottom: 1px solid #ced4da;
}
.rte-btn {
  border: 1px solid transparent;
  background: transparent;
  border-radius: .25rem;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.rte-btn:hover {
  background: #e9ecef;
  border-color: #dee2e6;
}
.rte-select {
  border: 1px solid #ced4da;
  border-radius: .25rem;
  padding: 4px 6px;
  background: #fff;
  font-size: .85rem;
  cursor: pointer;
}
.rte-color-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding: 0 4px;
}
.rte-color {
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  background: none;
  cursor: pointer;
}
.rte-separator {
  width: 1px;
  height: 24px;
  background: #ced4da;
  margin: 0 4px;
}
.rte-content {
  min-height: 220px;
  max-height: 500px;
  overflow-y: auto;
  padding: 12px;
  outline: none;
  line-height: 1.7;
}
.rte-content:empty:before {
  content: attr(data-placeholder);
  color: #adb5bd;
}
</style>